(() => {
  const qs=(s,r=document)=>r.querySelector(s), qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const money=(cents,currency='USD')=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format((Number(cents)||0)/100);
  const I18N=window.THEME_I18N||{};
  const tr=(key,fallback)=>I18N[key]||fallback;
  const fmt=(value,replacements={})=>Object.entries(replacements).reduce((out,[k,v])=>out.split(`__${k}__`).join(String(v)),String(value||''));

  function initAnnouncement(){qsa('[data-announcement]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='1';const track=qs('[data-announcement-track]',root);const items=qsa('[data-announcement-item]',root);if(!track||items.length<2)return;let i=0;const go=n=>{i=(n+items.length)%items.length;track.style.transform=`translateX(-${i*100}%)`};qs('[data-prev]',root)?.addEventListener('click',()=>go(i-1));qs('[data-next]',root)?.addEventListener('click',()=>go(i+1));});}

  function initHeader(){qsa('[data-mobile-toggle]').forEach(btn=>{if(btn.dataset.bound)return;btn.dataset.bound='1';btn.addEventListener('click',()=>{const menu=qs('[data-mobile-menu]');menu?.classList.toggle('is-open');btn.setAttribute('aria-expanded',menu?.classList.contains('is-open')?'true':'false')})});}

  const Cart=(()=>{
    let drawer,overlay,body,count,titleCount,subtotal,checkoutTotal,checkoutLink,shippingCopy,shippingBar,reserveBar,reserveTime,upsells=[],giftRules=[],reservationInterval;
    const P={bundle:'_theme_bundle_id',role:'_theme_bundle_role',giftVariant:'_theme_gift_variant_id',giftProduct:'_theme_gift_product_id',parentVariant:'_theme_parent_variant_id',parentProduct:'_theme_parent_product_id',offer:'_theme_bundle_offer'};
    const BP={bundle:'_beet_bundle_id',role:'_beet_bundle_role',parentVariant:'_beet_parent_variant_id',offerTier:'_beet_offer_tier'};
    const AG={flag:'_theme_auto_gift',rule:'_theme_gift_rule',label:'_theme_gift_label'};
    const CHECKOUT_PROP='_checkout_target';
    const esc=v=>String(v??'').replace(/[&<>'"]/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
    const props=it=>it?.properties||{};
    const role=it=>String(props(it)[P.role]||'');
    const bundle=it=>String(props(it)[P.bundle]||'');
    const isGift=it=>role(it)==='gift'&&bundle(it);
    const isPaid=it=>role(it)==='paid'&&bundle(it);
    const beetBundle=it=>String(props(it)[BP.bundle]||'');
    const beetRole=it=>String(props(it)[BP.role]||'');
    const isBeetGift=it=>beetRole(it)==='gift'&&beetBundle(it);
    const isBeetPaid=it=>beetRole(it)==='paid'&&beetBundle(it);
    const isAutoGift=it=>String(props(it)[AG.flag]||'')==='1'&&String(props(it)[AG.rule]||'');
    const anyGift=it=>isGift(it)||isBeetGift(it)||isAutoGift(it);
    const trashIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 10v7m4-7v7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    async function get(){
      const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error(tr('cartUnavailable','Cart unavailable'));
      return r.json();
    }
    async function postUpdate(updates){
      if(!Object.keys(updates||{}).length)return;
      const r=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
      if(!r.ok){const d=await r.json().catch(()=>({}));throw new Error(d.description||tr('cartUpdateError','Could not update cart.'));}
    }
    async function postAdd(items){
      if(!items?.length)return;
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      if(!r.ok){const d=await r.json().catch(()=>({}));throw new Error(d.description||tr('cartAddOfferError','Could not add offer to cart.'));}
    }
    async function normalize(cart){
      cart=cart||await get();
      const paidByBundle=new Map(),giftByBundle=new Map(),beetPaidByBundle=new Map(),beetGiftsByBundle=new Map();
      cart.items.forEach(it=>{
        const bid=bundle(it);
        if(bid){if(isPaid(it))paidByBundle.set(bid,it);if(isGift(it))giftByBundle.set(bid,it);}
        const bbid=beetBundle(it);
        if(bbid){if(isBeetPaid(it))beetPaidByBundle.set(bbid,it);if(isBeetGift(it)){const arr=beetGiftsByBundle.get(bbid)||[];arr.push(it);beetGiftsByBundle.set(bbid,arr);}}
      });
      const updates={},additions=[];
      giftByBundle.forEach((gift,bid)=>{if(!paidByBundle.get(bid))updates[gift.key]=0;});
      beetGiftsByBundle.forEach((gifts,bid)=>{if(!beetPaidByBundle.get(bid))gifts.forEach(g=>updates[g.key]=0);});
      paidByBundle.forEach((paid,bid)=>{
        const gift=giftByBundle.get(bid);
        const giftVariant=Number(props(paid)[P.giftVariant]||0);
        if(!gift&&giftVariant){
          additions.push({id:giftVariant,quantity:paid.quantity,properties:{[P.bundle]:bid,[P.role]:'gift',[P.parentVariant]:String(paid.variant_id),[P.parentProduct]:String(paid.product_id),[P.offer]:String(props(paid)[P.offer]||'Bundle Gift')}});
        }else if(gift&&gift.quantity!==paid.quantity){updates[gift.key]=paid.quantity;}
      });
      // Generic theme-editor gift rules. These auto-add/remove gift products; use a $0 gift product
      // or a matching Shopify automatic discount when the gift should be free.
      const activeRules=new Map(giftRules.map(node=>[String(node.dataset.ruleId||''),node]).filter(([id])=>id));
      const paidItems=cart.items.filter(it=>!anyGift(it));
      const paidProductIds=new Set(paidItems.map(it=>Number(it.product_id)).filter(Boolean));
      const paidSubtotal=paidItems.reduce((sum,it)=>sum+finalLine(it),0);
      const autoByRule=new Map();
      cart.items.filter(isAutoGift).forEach(it=>autoByRule.set(String(props(it)[AG.rule]||''),it));
      const qualifies=node=>{
        const condition=String(node.dataset.condition||'any');
        const trigger=Number(node.dataset.triggerProduct||0);
        const threshold=Math.max(0,Number(node.dataset.minSubtotal||0));
        const hasProduct=trigger?paidProductIds.has(trigger):false;
        const hasSpend=threshold?paidSubtotal>=threshold:false;
        if(condition==='product')return !!trigger&&hasProduct;
        if(condition==='subtotal')return !!threshold&&hasSpend;
        if(condition==='both')return (!trigger||hasProduct)&&(!threshold||hasSpend)&&(!!trigger||!!threshold);
        return (trigger&&hasProduct)||(threshold&&hasSpend);
      };
      autoByRule.forEach((gift,rid)=>{const rule=activeRules.get(rid);if(!rule||!qualifies(rule))updates[gift.key]=0;});
      activeRules.forEach((rule,rid)=>{
        if(!qualifies(rule)||autoByRule.has(rid))return;
        const giftVariant=Number(rule.dataset.giftVariant||0);if(!giftVariant)return;
        additions.push({id:giftVariant,quantity:Math.max(1,Number(rule.dataset.quantity||1)),properties:{[AG.flag]:'1',[AG.rule]:rid,[AG.label]:String(rule.dataset.label||'Gift with order')}});
      });
      if(Object.keys(updates).length)await postUpdate(updates);
      if(additions.length)await postAdd(additions);
      return (Object.keys(updates).length||additions.length)?await get():cart;
    }
    function pairedGift(cart,item){
      const bid=bundle(item);if(!bid)return null;
      return cart.items.find(x=>isGift(x)&&bundle(x)===bid)||null;
    }
    async function change(item,newQty,cart){
      if(anyGift(item))return;
      const q=Math.max(0,Number(newQty)||0),updates={[item.key]:q};
      if(isPaid(item)){
        const gift=pairedGift(cart,item);
        if(gift)updates[gift.key]=q;
      }
      if(isBeetPaid(item)&&q===0){
        const bid=beetBundle(item);cart.items.filter(x=>isBeetGift(x)&&beetBundle(x)===bid).forEach(g=>updates[g.key]=0);
      }
      await postUpdate(updates);
      await render();
    }
    function originalLine(it){return Number(it.original_line_price??it.line_price??it.final_line_price??0)||0;}
    function finalLine(it){return Number(it.final_line_price??it.line_price??0)||0;}
    function renderPrice(it,gift,currency){
      const original=originalLine(it),final=finalLine(it);
      if(gift){return `<div class="k-cart-item__price">${original?`<s>${money(original,currency)}</s>`:''}<span class="k-cart-free-badge">${esc(tr('free','FREE'))}</span></div>`;}
      if(original>final){return `<div class="k-cart-item__price"><s>${money(original,currency)}</s><strong>${money(final,currency)}</strong></div>`;}
      return `<div class="k-cart-item__price"><strong>${money(final,currency)}</strong></div>`;
    }
    function updateShipping(cart){
      if(!drawer||!shippingCopy||!shippingBar)return;
      const threshold=Math.max(0,Number(drawer.dataset.freeShippingThreshold||0));
      if(!threshold){shippingBar.style.width='100%';shippingCopy.textContent='';return;}
      const total=Math.max(0,Number(cart.total_price)||0),remaining=Math.max(0,threshold-total),pct=Math.max(0,Math.min(100,total/threshold*100));
      shippingBar.style.width=`${pct}%`;
      if(remaining>0){
        const prefix=esc(drawer.dataset.freePrefix||tr('spend','Spend')),suffix=esc(drawer.dataset.freeSuffix||tr('moreFor','more for')),label=esc(drawer.dataset.freeLabel||tr('freeShipping','free shipping'));
        shippingCopy.innerHTML=`${prefix} ${money(remaining,cart.currency||'USD')} ${suffix} <span class="is-free">${label}</span>`;
      }else{
        shippingCopy.innerHTML=`<span class="is-free">${esc(drawer.dataset.freeUnlocked||tr('freeShippingUnlocked',"You've unlocked free shipping"))}</span>`;
      }
    }
    function reservationStorageKey(){return 'theme_cart_reservation_until';}
    function setReservationUntil(value){try{localStorage.setItem(reservationStorageKey(),String(value));}catch(e){}}
    function clearReservation(){try{localStorage.removeItem(reservationStorageKey());}catch(e){}}
    function getReservationUntil(){try{return Number(localStorage.getItem(reservationStorageKey())||0)||0;}catch(e){return 0;}}
    function ensureReservation(cart){
      if(!reserveBar||!reserveTime)return;
      if(!cart.item_count){reserveBar.hidden=true;clearReservation();if(reservationInterval){clearInterval(reservationInterval);reservationInterval=null;}return;}
      reserveBar.hidden=false;
      const duration=Math.max(1,Number(drawer?.dataset.reservationMinutes||10))*60*1000;
      let until=getReservationUntil();
      if(!until||until<=Date.now()){until=Date.now()+duration;setReservationUntil(until);}
      const tick=()=>{
        let left=Math.max(0,getReservationUntil()-Date.now());
        if(left<=0){const next=Date.now()+duration;setReservationUntil(next);left=duration;}
        const seconds=Math.ceil(left/1000),m=Math.floor(seconds/60),s=seconds%60;
        reserveTime.textContent=`${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      };
      tick();
      if(!reservationInterval)reservationInterval=setInterval(tick,1000);
    }
    function updateUpsellVariant(node){
      if(!node)return;
      const select=qs('[data-cart-upsell-variant]',node);
      const priceEl=qs('[data-cart-upsell-price]',node);
      const compareEl=qs('[data-cart-upsell-compare]',node);
      const image=qs('.k-cart-upsell__image',node);
      const opt=select?.selectedOptions?.[0];
      const price=Number(opt?.dataset.price||priceEl?.dataset.price||0);
      const compare=Number(opt?.dataset.compare||0);
      if(priceEl&&price)priceEl.textContent=money(price);
      if(compareEl){compareEl.hidden=!(compare>price);if(compare>price)compareEl.textContent=money(compare);}
      if(image&&opt?.dataset.image)image.src=opt.dataset.image;
    }
    function updateUpsellVisibility(cart){
      if(!upsells.length)return;
      upsells.forEach(node=>node.hidden=true);
      if(!cart?.item_count)return;
      const paidItems=(cart.items||[]).filter(it=>!anyGift(it));
      const productIds=new Set(paidItems.map(it=>Number(it.product_id)).filter(Boolean));
      const available=node=>{
        const pid=Number(node.dataset.productId||0);
        if(!pid)return false;
        if(node.dataset.hideIfPresent==='true'&&productIds.has(pid))return false;
        return true;
      };
      const matchingRules=upsells.filter(node=>node.dataset.upsellType==='rule'&&Number(node.dataset.triggerProduct||0)&&productIds.has(Number(node.dataset.triggerProduct))&&available(node));
      matchingRules.forEach(node=>node.hidden=false);
      if(!matchingRules.length&&productIds.size===1){
        const chosen=upsells.find(node=>node.dataset.upsellType==='fallback'&&available(node))||upsells.find(node=>node.dataset.upsellType==='auto'&&available(node));
        if(chosen)chosen.hidden=false;
      }
    }
    async function render(){
      if(!body)return null;
      let cart=await normalize(await get());
      const currency=cart.currency||'USD';
      if(count)count.textContent=cart.item_count;
      if(titleCount)titleCount.textContent=cart.item_count;
      if(subtotal)subtotal.textContent=money(cart.total_price,currency);
      if(checkoutTotal)checkoutTotal.textContent=money(cart.total_price,currency);
      if(checkoutLink)checkoutLink.setAttribute('aria-disabled',cart.item_count?'false':'true');
      updateShipping(cart);ensureReservation(cart);updateUpsellVisibility(cart);
      body.innerHTML=cart.items.length?cart.items.map(it=>{
        const gift=anyGift(it),bid=bundle(it)||beetBundle(it)||String(props(it)[AG.rule]||'');
        const variant=(it.variant_title&&it.variant_title!=='Default Title')?esc(it.variant_title):'';
        const qty=gift
          ? `<div class="k-cart-gift-lock"><small>${esc(fmt(tr('linkedGiftQuantity','Qty __COUNT__ · linked gift'),{COUNT:it.quantity}))}</small></div>`
          : `<div class="k-cart-item__qty"><button type="button" data-cart-key="${esc(it.key)}" data-q="${Math.max(0,it.quantity-1)}" aria-label="${esc(tr('decreaseQuantity','Decrease quantity'))}">−</button><span>${it.quantity}</span><button type="button" data-cart-key="${esc(it.key)}" data-q="${it.quantity+1}" aria-label="${esc(tr('increaseQuantity','Increase quantity'))}">+</button></div>`;
        const remove=gift?'':`<button type="button" class="k-cart-remove" data-cart-remove="${esc(it.key)}" aria-label="${esc(fmt(tr('removeItem','Remove __PRODUCT__'),{PRODUCT:it.product_title}))}">${trashIcon}</button>`;
        return `<div class="k-cart-item${gift?' is-gift':''}" data-cart-item-key="${esc(it.key)}"${bid?` data-bundle-id="${esc(bid)}"`:''}>
          <a class="k-cart-item__image-wrap" href="${esc(it.url)}"><img class="k-cart-item__image" src="${esc(it.image||'')}" alt=""></a>
          <div class="k-cart-item__main"><a class="k-cart-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a><div class="k-cart-item__meta">${variant}</div>${qty}</div>
          <div class="k-cart-item__side">${remove}${renderPrice(it,gift&&finalLine(it)===0,currency)}</div>
        </div>`;
      }).join(''):`<p style="padding:36px 0;text-align:center;color:#777">${esc(tr('emptyCart','Your cart is empty.'))}</p>`;
      qsa('[data-cart-key]',body).forEach(btn=>btn.addEventListener('click',async()=>{
        const item=cart.items.find(x=>x.key===btn.dataset.cartKey);if(!item)return;
        btn.disabled=true;try{await change(item,Number(btn.dataset.q),cart)}finally{btn.disabled=false;}
      }));
      qsa('[data-cart-remove]',body).forEach(btn=>btn.addEventListener('click',async()=>{
        const item=cart.items.find(x=>x.key===btn.dataset.cartRemove);if(!item)return;
        btn.disabled=true;try{await change(item,0,cart)}finally{btn.disabled=false;}
      }));
      return cart;
    }
    function show(){drawer?.classList.add('is-open');overlay?.classList.add('is-open');document.body.style.overflow='hidden';}
    async function open(){show();try{await render()}catch(e){console.error(e);}}
    function close(){drawer?.classList.remove('is-open');overlay?.classList.remove('is-open');document.body.style.overflow='';}
    const checkoutTargetFromForm=form=>String(new FormData(form).get('properties[_checkout_target]')||'current');
    const checkoutTargetFromCart=cart=>{
      const item=(cart?.items||[]).find(it=>!anyGift(it)&&String(props(it)[CHECKOUT_PROP]||'')&&String(props(it)[CHECKOUT_PROP])!=='current');
      return item?String(props(item)[CHECKOUT_PROP]||'current'):'current';
    };
    function submitLocalizedCheckout(target,href){
      const parts=String(target||'').split('_');
      if(parts.length<2){location.href=href;return;}
      const country=parts[0],language=parts.slice(1).join('-').toLowerCase();
      const f=document.createElement('form');f.method='post';f.action='/localization';f.style.display='none';
      [['form_type','localization'],['utf8','✓'],['_method','put'],['country_code',country],['language_code',language],['return_to',href]].forEach(([name,value])=>{const i=document.createElement('input');i.type='hidden';i.name=name;i.value=value;f.appendChild(i)});
      document.body.appendChild(f);f.submit();
    }
    async function add(form){
      const bogo=qs('[data-bogo-offer]',form);
      let r;
      if(bogo){
        const paidSel=qs('[data-bogo-select][data-bogo-role="paid"]',bogo);
        const giftSel=qs('[data-bogo-select][data-bogo-role="gift"]',bogo);
        const paidId=Number(paidSel?.value||0),giftId=Number(giftSel?.value||0);
        if(paidId&&giftId){
          const bundleId=`bundle-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,9)}`;
          const paidProduct=String(bogo.dataset.paidProductId||'');
          const giftProduct=String(bogo.dataset.giftProductId||'');
          const checkoutTarget=checkoutTargetFromForm(form);
          const paidProps={[P.bundle]:bundleId,[P.role]:'paid',[P.giftVariant]:String(giftId),[P.giftProduct]:giftProduct,[P.offer]:'Bundle Gift'};
          if(checkoutTarget&&checkoutTarget!=='current')paidProps[CHECKOUT_PROP]=checkoutTarget;
          await postAdd([
            {id:paidId,quantity:1,properties:paidProps},
            {id:giftId,quantity:1,properties:{[P.bundle]:bundleId,[P.role]:'gift',[P.parentVariant]:String(paidId),[P.parentProduct]:paidProduct,[P.offer]:'Bundle Gift'}}
          ]);
          clearReservation();show();await render();return;
        }
      }
      const beetUnlocked=qsa('[data-beet-gift][data-unlocked="true"][data-gift-variant-id]',form);
      if(beetUnlocked.length){
        const fd=new FormData(form),paidId=Number(fd.get('id')||0),paidQty=Math.max(1,Number(fd.get('quantity')||1));
        if(paidId){
          const bundleId=`beet-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,9)}`;
          const tier=String(qs('[data-beet-offer].is-selected',form)?.dataset.tier||'1');
          const paidProps={[BP.bundle]:bundleId,[BP.role]:'paid',[BP.offerTier]:tier};const checkoutTarget=checkoutTargetFromForm(form);if(checkoutTarget&&checkoutTarget!=='current')paidProps[CHECKOUT_PROP]=checkoutTarget;
          const paidItem={id:paidId,quantity:paidQty,properties:paidProps};
          const sellingPlan=Number(fd.get('selling_plan')||0);if(sellingPlan)paidItem.selling_plan=sellingPlan;
          const giftItems=beetUnlocked.map(g=>({id:Number(g.dataset.giftVariantId),quantity:1,properties:{[BP.bundle]:bundleId,[BP.role]:'gift',[BP.parentVariant]:String(paidId),[BP.offerTier]:tier}})).filter(x=>x.id);
          await postAdd([paidItem,...giftItems]);
          clearReservation();show();await render();return;
        }
      }
      const fd=new FormData(form);
      r=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
      if(!r.ok){const d=await r.json().catch(()=>({}));throw new Error(d.description||tr('cartAddError','Could not add to cart.'));}
      clearReservation();show();await render();
    }
    async function checkout(href='/checkout'){
      const cart=await normalize(await get());
      if(!cart.item_count)return;
      const target=checkoutTargetFromCart(cart);
      if(target&&target!=='current'){submitLocalizedCheckout(target,href);return;}
      location.href=href;
    }
    function initUpsell(node){
      if(!node||node.dataset.upsellBound)return;
      node.dataset.upsellBound='1';
      const select=qs('[data-cart-upsell-variant]',node);
      const addBtn=qs('[data-cart-upsell-add]',node);
      select?.addEventListener('change',()=>updateUpsellVariant(node));
      addBtn?.addEventListener('click',async()=>{
        const id=Number(select?.value||node.dataset.defaultVariant||0);if(!id)return;
        const old=addBtn.textContent;addBtn.disabled=true;addBtn.textContent=tr('adding','ADDING…');
        try{await postAdd([{id,quantity:1}]);await render();}catch(err){alert(err.message||tr('cartAddUpsellError','Could not add upsell.'));}finally{addBtn.disabled=false;addBtn.textContent=old;}
      });
      updateUpsellVariant(node);
    }
    function init(){
      drawer=qs('[data-cart-drawer]');overlay=qs('[data-cart-overlay]');body=qs('[data-cart-body]');count=qs('[data-cart-count]');titleCount=qs('[data-cart-title-count]');subtotal=qs('[data-cart-subtotal]');checkoutTotal=qs('[data-cart-checkout-total]');checkoutLink=qs('[data-cart-checkout]');shippingCopy=qs('[data-cart-shipping-copy]');shippingBar=qs('[data-cart-shipping-bar]');reserveBar=qs('[data-cart-reserve]');reserveTime=qs('[data-cart-reserve-time]');upsells=qsa('[data-cart-upsell]');giftRules=qsa('[data-cart-gift-rule]');
      upsells.forEach(initUpsell);
      qsa('[data-cart-open]').forEach(b=>{if(b.dataset.cartBound)return;b.dataset.cartBound='1';b.addEventListener('click',e=>{e.preventDefault();open();});});
      qsa('[data-cart-close]').forEach(b=>{if(b.dataset.cartBound)return;b.dataset.cartBound='1';b.addEventListener('click',close);});
      if(overlay&&!overlay.dataset.cartBound){overlay.dataset.cartBound='1';overlay.addEventListener('click',close);}
      qsa('[data-cart-checkout]').forEach(a=>{if(a.dataset.cartBound)return;a.dataset.cartBound='1';a.addEventListener('click',e=>{e.preventDefault();checkout(a.getAttribute('href')||'/checkout').catch(err=>console.error(err));});});
      if(!document.documentElement.dataset.ajaxCartBound){
        document.documentElement.dataset.ajaxCartBound='1';
        document.addEventListener('submit',e=>{
          const form=e.target.closest('form[data-ajax-product-form]');if(!form)return;
          // Kaching Bundles/upsells may need to transform one submit into multiple
          // cart lines. When its widget is present, let Kaching own the submission.
          if(form.querySelector('kaching-bundle, kaching-bundles-block'))return;
          e.preventDefault();
          const btn=qs('[type="submit"]',form);if(btn){btn.disabled=true;btn.dataset.old=btn.textContent;btn.textContent=tr('adding','ADDING…');}
          add(form).catch(err=>alert(err.message)).finally(()=>{if(btn){btn.disabled=false;btn.textContent=btn.dataset.old||tr('addToCart','ADD TO CART');}});
        },true);
      }
      if(drawer)render().catch(()=>{});else normalize().catch(()=>{});
    }
    return{init,open,render,normalize,get,checkout,update:postUpdate};
  })();

  const norm=v=>String(v??'').trim().toLowerCase();

  function getVariantGalleryDef(sec, variant){
    if(!sec||!variant)return null;
    const options=variant.options||[];
    return qsa('[data-variant-gallery-definition]',sec).find(def=>{
      const pos=Math.max(0,Number(def.dataset.optionPosition||1)-1);
      return norm(options[pos])===norm(def.dataset.optionValue);
    })||null;
  }

  function setGalleryGroup(sec, variant, preferVariantImage=false){
    const gallery=qs('[data-product-gallery]',sec); if(!gallery)return;
    const main=qs('[data-gallery-main]',gallery); if(!main)return;
    const def=getVariantGalleryDef(sec,variant);
    const group=def?.dataset.group||'default';
    const all=qsa('[data-gallery-thumb]',gallery);
    const visible=[];
    all.forEach(btn=>{
      const show=(btn.dataset.galleryGroup||'default')===group;
      btn.hidden=!show;
      if(show)visible.push(btn);
    });
    main.style.objectFit=def?.dataset.fit||gallery.dataset.defaultFit||'cover';
    let target=null;
    if(!def && preferVariantImage && variant?.featured_image?.src){
      const filename=(variant.featured_image.src.split('/').pop()||'').split('?')[0];
      target=visible.find(t=>(t.dataset.src||'').split('?')[0].endsWith(filename));
    }
    if(!target)target=visible.find(t=>t.classList.contains('is-active'))||visible[0];
    all.forEach(x=>x.classList.remove('is-active'));
    if(target){
      target.classList.add('is-active');
      main.src=target.dataset.src||main.src;
      main.srcset='';
      main.alt=target.dataset.alt||main.alt||'';
      target.scrollIntoView({block:'nearest',inline:'nearest'});
    }else if(!def && variant?.featured_image?.src){
      main.src=variant.featured_image.src;
      main.srcset='';
    }
    gallery.dataset.activeGroup=group;
  }

  function getOfferImage(sec,variant,opt){
    const def=getVariantGalleryDef(sec,variant);
    if(def?.dataset.offerImage)return def.dataset.offerImage;
    if(def){
      const first=qsa('[data-gallery-thumb]',sec).find(t=>t.dataset.galleryGroup===def.dataset.group);
      if(first?.dataset.src)return first.dataset.src;
    }
    return opt?.dataset.image||variant?.featured_image?.src||'';
  }

  function initGalleries(root=document){
    qsa('[data-product-gallery]',root).forEach(g=>{
      if(g.dataset.bound)return; g.dataset.bound='1';
      const main=qs('[data-gallery-main]',g);
      qsa('[data-gallery-thumb]',g).forEach(btn=>btn.addEventListener('click',()=>{
        if(btn.hidden)return;
        qsa('[data-gallery-thumb]',g).forEach(x=>x.classList.remove('is-active'));
        btn.classList.add('is-active');
        if(main){main.src=btn.dataset.src||main.src;main.srcset='';main.alt=btn.dataset.alt||''}
        btn.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
      }));
      const thumbs=qs('[data-gallery-thumbs]',g);
      qsa('[data-gallery-scroll]',g).forEach(nav=>nav.addEventListener('click',()=>{
        if(!thumbs)return;
        const horizontal=getComputedStyle(thumbs).flexDirection==='row';
        const amount=(horizontal?thumbs.clientWidth:thumbs.clientHeight)*.72;
        thumbs.scrollBy(horizontal?{left:nav.dataset.galleryScroll==='up'?-amount:amount,behavior:'smooth'}:{top:nav.dataset.galleryScroll==='up'?-amount:amount,behavior:'smooth'});
      }));
    });
  }

  function initProducts(root=document){
    qsa('[data-product-root]',root).forEach(sec=>{
      if(sec.dataset.bound)return; sec.dataset.bound='1';
      let variants=[];
      try{variants=JSON.parse(qs('[data-product-variants]',sec)?.textContent||'[]')}catch(e){}
      const form=qs('[data-ajax-product-form]',sec);
      if(!form)return;
      const id=qs('[name="id"]',form);
      const price=qs('[data-product-price]',sec);
      const compare=qs('[data-product-compare]',sec);
      const buy=qs('[data-product-buy]',sec);
      const currency=sec.dataset.currency||'USD';
      const selects=qsa('[data-option-select]',sec);
      const buttons=qsa('[data-option-button]',sec);
      const bogoSelects=qsa('[data-bogo-select]',sec);
      let changedPos=null;

      const variantById=value=>variants.find(v=>String(v.id)===String(value));
      const currentVariant=()=>variantById(id?.value)||variants.find(v=>v.available)||variants[0];

      const updateCommon=(v,{gallery=true}={})=>{
        if(!v)return;
        if(id){
          const changed=String(id.value)!==String(v.id);
          id.value=v.id;
          if(changed){
            id.dispatchEvent(new Event('input',{bubbles:true}));
            id.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }
        if(price)price.textContent=money(v.price,currency);
        if(compare){compare.textContent=v.compare_at_price?money(v.compare_at_price,currency):'';compare.hidden=!(v.compare_at_price>v.price)}
        if(buy){buy.disabled=!v.available;buy.textContent=v.available?((buy.dataset.label||tr('addToCart','ADD TO CART'))+(buy.dataset.showPrice==='true'?` · ${money(v.price,currency)}`:'')):(buy.dataset.soldout||tr('soldOut','SOLD OUT'))}
        if(history.replaceState){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
        if(gallery)setGalleryGroup(sec,v,true);
        sec.dispatchEvent(new CustomEvent('kalm:variant-change',{detail:{variant:v},bubbles:true}));
      };

      const bestVariant=opts=>{
        const exact=variants.find(v=>(v.options||[]).every((o,i)=>o===opts[i]));
        if(exact)return exact;
        const candidates=variants.filter(v=>v.available&&(!changedPos||v.options?.[changedPos-1]===opts[changedPos-1]));
        const pool=candidates.length?candidates:variants.filter(v=>v.available);
        return pool.sort((a,b)=>{
          const score=v=>(v.options||[]).reduce((n,o,i)=>n+(o===opts[i]?1:0),0);
          return score(b)-score(a);
        })[0]||variants[0];
      };

      const syncStandard=()=>{
        if(!selects.length){const v=currentVariant(); if(v)updateCommon(v); return;}
        const opts=selects.map(s=>s.value);
        const v=bestVariant(opts); if(!v)return;
        if(v.options){selects.forEach((sel,i)=>{if(v.options[i]!=null&&sel.value!==v.options[i])sel.value=v.options[i]})}
        const selected=selects.map(s=>s.value);
        buttons.forEach(b=>{
          const pos=Number(b.dataset.optionPosition)-1, val=b.dataset.optionValue;
          const active=selected[pos]===val;
          b.classList.toggle('is-active',active); b.setAttribute('aria-pressed',active?'true':'false');
          const viable=variants.some(x=>x.available&&x.options?.every((o,i)=>i===pos?o===val:o===selected[i]));
          b.disabled=!viable&&!active;
          const def=qsa('[data-variant-gallery-definition]',sec).find(d=>Number(d.dataset.optionPosition)-1===pos&&norm(d.dataset.optionValue)===norm(val));
          const sw=qs('.k-option-swatch',b); if(sw&&def?.dataset.swatch)sw.style.background=def.dataset.swatch;
        });
        qsa('[data-selected-option]',sec).forEach(label=>{const pos=Number(label.dataset.selectedOption)-1;if(selected[pos]!=null)label.textContent=selected[pos]});
        updateCommon(v); changedPos=null;
      };

      const syncBogo=()=>{
        bogoSelects.forEach(sel=>{
          const opt=sel.options[sel.selectedIndex]; if(!opt)return;
          const wrap=sel.closest('.k-bogo-product');
          const role=sel.dataset.bogoRole||'paid';
          const v=role==='paid'?variantById(opt.value):null;
          const def=role==='paid'?getVariantGalleryDef(sec,v):null;
          const swatch=qs('[data-bogo-swatch]',wrap);
          if(swatch)swatch.style.background=def?.dataset.swatch||opt.dataset.color||'#d8d8d8';
          const img=qs('.k-bogo-product__image img',wrap);
          const image=role==='paid'?getOfferImage(sec,v,opt):(wrap?.dataset.freeImageOverride||opt.dataset.image||'');
          if(img&&image){img.src=image;img.srcset='';}
          const comp=qs(role==='paid'?'[data-bogo-primary-compare]':'[data-bogo-free-compare]',wrap);
          if(comp){const c=role==='gift'?Number(opt.dataset.price||0):Number(opt.dataset.compare||0);comp.textContent=c?money(c,currency):'';comp.hidden=!c;}
        });
        const primarySel=bogoSelects.find(s=>s.dataset.bogoRole==='paid');
        const giftSel=bogoSelects.find(s=>s.dataset.bogoRole==='gift');
        const primary=primarySel?.options[primarySel.selectedIndex];
        const gift=giftSel?.options[giftSel.selectedIndex];
        if(primary){
          const v=variantById(primary.value);
          const p=Number(primary.dataset.price||v?.price||0);
          const c=Number(primary.dataset.compare||v?.compare_at_price||0);
          const giftValue=Number(gift?.dataset.price||0);
          const compareValue=(c>p?c:p)+giftValue;
          const total=qs('[data-bogo-total-price]',sec),totalCompare=qs('[data-bogo-total-compare]',sec),primaryPrice=qs('[data-bogo-primary-price]',sec);
          if(total)total.textContent=money(p,currency);
          if(primaryPrice)primaryPrice.textContent=money(p,currency);
          if(totalCompare){totalCompare.textContent=compareValue>p?money(compareValue,currency):'';totalCompare.hidden=!(compareValue>p);}
          if(v)updateCommon(v);
        }
      };

      bogoSelects.forEach(sel=>sel.addEventListener('change',syncBogo));
      selects.forEach(sel=>sel.addEventListener('change',()=>{changedPos=Number(sel.dataset.optionPosition)||null;syncStandard()}));
      buttons.forEach(b=>b.addEventListener('click',()=>{
        const pos=Number(b.dataset.optionPosition), sel=selects.find(x=>Number(x.dataset.optionPosition)===pos);
        if(!sel||b.disabled)return; changedPos=pos; sel.value=b.dataset.optionValue; syncStandard();
      }));

      if(bogoSelects.length)syncBogo(); else syncStandard();
    });
  }

  function initCartPage(){
    const form=qs('[data-cart-page-form]');
    if(!form||form.dataset.bound)return;
    form.dataset.bound='1';
    const buildUpdates=async()=>{
      const cart=await Cart.get();
      const inputs=qsa('[data-cart-page-qty]',form);
      const desired=new Map(inputs.map(i=>[i.dataset.itemKey,Math.max(0,Number(i.value)||0)]));
      const byBundle=new Map();
      cart.items.forEach(it=>{
        const p=it.properties||{},bid=String(p._theme_bundle_id||''),role=String(p._theme_bundle_role||'');
        if(!bid)return;
        if(!byBundle.has(bid))byBundle.set(bid,{});
        byBundle.get(bid)[role]=it;
      });
      const updates={};
      cart.items.forEach(it=>{
        const p=it.properties||{},role=String(p._theme_bundle_role||''),bid=String(p._theme_bundle_id||'');
        const autoGift=String(p._theme_auto_gift||'')==='1';
        if(role==='gift'||autoGift)return;
        if(desired.has(it.key))updates[it.key]=desired.get(it.key);
        if(role==='paid'&&bid){
          const gift=byBundle.get(bid)?.gift;
          if(gift)updates[gift.key]=updates[it.key]??it.quantity;
        }
      });
      await Cart.update(updates);
      await Cart.normalize();
    };
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const btn=e.submitter; if(btn)btn.disabled=true;
      try{await buildUpdates();location.reload()}catch(err){alert(err.message||tr('cartUpdateError','Could not update cart.'));if(btn)btn.disabled=false}
    });
    qs('[data-cart-page-checkout]',form)?.addEventListener('click',async e=>{
      e.preventDefault(); e.currentTarget.disabled=true;
      try{await buildUpdates();await Cart.checkout('/checkout')}catch(err){alert(err.message||tr('cartValidateError','Could not validate cart.'));e.currentTarget.disabled=false}
    });
  }

  function initQuiz(root=document){const modal=qs('[data-quiz-modal]');if(!modal)return;if(modal.dataset.bound)return;modal.dataset.bound='1';const shell=qs('.k-quiz-shell',modal),steps=qsa('[data-quiz-step]',modal),result=qs('[data-quiz-result]',modal),progress=qs('[data-quiz-progress]',modal),totalNodes=qsa('[data-quiz-total]',modal);let index=0,score=0;let results={};try{results=JSON.parse(qs('[data-quiz-results]',modal)?.textContent||'{}')}catch(e){}totalNodes.forEach(n=>n.textContent=steps.length);
    const paint=()=>{steps.forEach((s,i)=>s.classList.toggle('is-active',i===index));if(progress)progress.style.width=`${steps.length?Math.min(100,(index/steps.length)*100):0}%`};
    const open=()=>{modal.hidden=false;requestAnimationFrame(()=>modal.classList.add('is-open'));document.body.style.overflow='hidden';index=0;score=0;if(result)result.hidden=true;paint();setTimeout(()=>qs('[data-quiz-answer]',steps[0]||modal)?.focus(),120)};
    const close=()=>{modal.classList.remove('is-open');document.body.style.overflow='';setTimeout(()=>{modal.hidden=true},220)};
    const finish=()=>{steps.forEach(s=>s.classList.remove('is-active'));if(progress)progress.style.width='100%';let r=score<=Number(results.low?.max??3)?results.low:score<=Number(results.mid?.max??7)?results.mid:results.high;if(!r)r=results.mid||results.low||results.high||{};qs('[data-quiz-result-badge]',modal).textContent=r.badge||'';qs('[data-quiz-result-title]',modal).textContent=r.title||'';const body=qs('[data-quiz-result-body]',modal);if(body)body.innerHTML=r.body||'';if(result)result.hidden=false};
    document.addEventListener('click',e=>{const opener=e.target.closest('[data-quiz-open]');if(opener){e.preventDefault();open()}});
    qsa('[data-quiz-close]',modal).forEach(b=>b.addEventListener('click',close));qsa('[data-quiz-answer]',modal).forEach(b=>b.addEventListener('click',()=>{score+=Number(b.dataset.score||0);index++;index>=steps.length?finish():paint()}));qs('[data-quiz-restart]',modal)?.addEventListener('click',()=>{index=0;score=0;if(result)result.hidden=true;paint()});qs('[data-quiz-result-button]',modal)?.addEventListener('click',e=>{const href=e.currentTarget.getAttribute('href')||'';if(href.startsWith('#')){e.preventDefault();close();setTimeout(()=>qs('[data-product-root]')?.scrollIntoView({behavior:'smooth',block:'start'}),230)}});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)close()});paint();}

  function init(){initAnnouncement();initHeader();Cart.init();initCartPage();initGalleries();initProducts();initQuiz()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',e=>{initAnnouncement();initHeader();initGalleries(e.target);initProducts(e.target);initQuiz(e.target)});
})();
